/* eslint-disable import/no-extraneous-dependencies */
// import sum from 'lodash/sum';
// import uniq from 'lodash/uniq';
// import uniqBy from 'lodash/uniqBy';
import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance } from "../../utils/axiosInstance"

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  saveTour: [],
  tourCityList: [],
  tourList: undefined,
  tourDetail: undefined,
  tourBookingRes: undefined,
  tourSearchRes: undefined,
  tourSearchListRes: undefined,
};

const slice = createSlice({
  name: 'tour',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    //GET getHotelCityList
    getTourListSuccess(state, action) {
      state.isLoading = false;
      state.tourList = action.payload;
    },
    getTourDetailSucess(state, action) {
      state.isLoading = false;
      state.tourDetail = action.payload;
    },
    tourSaveBookingSuccess(state, action) {
      state.isLoading = false;
      state.tourBookingRes = action.payload;
    },
    tourFilterListSuccess(state, action) {
      state.isLoading = false;
      state.tourFilterRes = action.payload;
    },
    getSearchTourSuccess(state, action) {
      state.isLoading = false;
      state.tourSearchRes = action.payload;
    },
    getSearchTourListSuccess(state, action) {
      state.isLoading = false;
      state.tourSearchListRes = action.payload;
    },
    getSearchTourFilterSuccess(state, action) {
      state.isLoading = false;
      state.tourSearchFilterRes = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getCart,
  addToCart,
  resetCart,
  gotoStep,
  backStep,
  nextStep,
  deleteCart,
  createBilling,
  applyShipping,
  applyDiscount,
  increaseQuantity,
  decreaseQuantity,
} = slice.actions;

// ----------------------------------------------------------------------

//SAVEHOTELSBOOKINGS

export function getTourList(hotelBooking) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/tour/list`,
        hotelBooking,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch(slice.actions.getTourListSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTourDetail(hotelBooking) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/tour/detail`,
        hotelBooking,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch(slice.actions.getTourDetailSucess(response.data.holidayPackage));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function holidaySaveBooking(hotelBooking) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/holidayPackage`,
        hotelBooking,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch(slice.actions.getHolidaySaveBookingSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function tourSaveBooking(hotelBooking) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/tourPackageBooking`,
        hotelBooking,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch(slice.actions.tourSaveBookingSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function tourFilterList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(
        `${process.env.BACKEND_URL}/tour/filterList`
      );

      dispatch(slice.actions.tourFilterListSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function searchTour(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/tour/searchHoliday`,
        obj
      );
      dispatch(slice.actions.getSearchTourSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function searchTourList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/tour/searchList`,
        obj
      );
      dispatch(
        slice.actions.getSearchTourListSuccess(response.data.responseData)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function searchTourFilter(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/tour/filterList`,
        obj
      );
      dispatch(
        slice.actions.getSearchTourFilterSuccess(response.data?.responseData)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
